import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/css/index.css";
import "./plugins/element.js";
import "./assets/css/tailwindcss.css";
import "./assets/css/quill.core.css";
import "./assets/css/quill.snow.css";
import "./assets/css/quill.bubble.css";
import Navbar from "./components/navbar.vue";
import Element from 'element-ui'
Vue.use(Navbar);
Vue.component("Navbar", Navbar);
Vue.config.productionTip = false;
Vue.prototype.$fileUrl = process.env.VUE_APP_FILE_URL;
Vue.prototype.$getMinPriceV2 = getMinPriceV2;
Vue.prototype.$isBlank = isBlank;
Vue.prototype.$isNotBlank = isNotBlank;

function getMinPriceV2(salePriceDay, len) {
  if (isBlank(len) || len <= 0) {
    return getMinPrice(salePriceDay);
  }
  // return this.getPrice(salePriceDay, len);
  return salePriceDay;
}
function getMinPrice(salePriceDay) {
  if (isBlank(salePriceDay)) {
    return 0;
  }
  if (salePriceDay.indexOf("{") < 0) {
    return parseFloat(salePriceDay);
  }
  var obj = JSON.parse(salePriceDay);
  var objKeys = [];
  Object.keys(obj).forEach(function (item) {
    objKeys.push(parseInt(item));
  });
  var price = [];
  objKeys.forEach(function (item) {
    price.push(obj[item]);
  }); //通过key查询到value
  price.sort(function (a, b) {
    return a >= b ? 1 : -1;
  });
  return parseFloat(price[0]);
}
function isBlank(str) {
  if (str instanceof Array) {
    return str.length == 0;
  }
  return str === undefined || str === null || str === "";
}
function isNotBlank(str) {
      return !isBlank(str);
    }
    Vue.use(Element)
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
